import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import ButtonBar from "../../components/button-bar/ButtonBar";
import { Location as LocationType } from '../../types/Artist';
import { Box, Stack, Typography } from "@mui/material";
import { getArtistsByLocation } from "../../components/apis/music-api";
import { format, getLetter, getLocationString } from "../../components/text-helper/text-helper";
import { ArtistMessage } from "../../types/ArtistMessage";
import callApi from "../../components/call-api/call-api";
import { Status, Wrapper } from '@googlemaps/react-wrapper';
import { MarkerClusterer } from "@googlemaps/markerclusterer";

type LocationProps = {
    country?: string,
    stateProvidence?: string
    city?: string,
}

const Location = () => {
    const params = useParams<LocationProps>();
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ artistMessages, setArtistMessages ] = useState<ArtistMessage[]>();
    const GoolgleApiKey = 'AIzaSyDSwvr2YTLE9ybiYn_15b1YLxcPqU5TDm0';
  
    const ref = useRef<HTMLDivElement>(null);
    const [ map, setMap ] = useState<google.maps.Map>();
    const [ markerCluster, setMarkerClusters ] = useState<MarkerClusterer>();

    useEffect(()=>{
        if (ref.current && !map && artistMessages && artistMessages.length > 0) {
            setMap(new window.google.maps.Map(ref.current, {
                center: { lat: artistMessages[0].coordinates?.latitude ?? 0, lng: artistMessages[0].coordinates?.longitude ?? 0 },
                zoom: 10,
            }));
        }
    }, [map, artistMessages]);
    
    useEffect(()=> {
        if (markerCluster) {
            artistMessages?.forEach(artistMessage => {
                if (artistMessage.coordinates != null) {
                    var position = {
                        position: {
                            lat: artistMessage.coordinates?.latitude ?? 0,
                            lng: artistMessage.coordinates?.longitude ?? 0
                        },
                        title: format(artistMessage.name),
                    };

                    var marker = new window.google.maps.Marker(position);
                    markerCluster.addMarker(marker);
                }
            });
        }
    }, [markerCluster, artistMessages]);

    useEffect(() => {
        if (map && !markerCluster) {
            setMarkerClusters(new MarkerClusterer({map, markers: [], }));
        }
    }, [map, markerCluster]);

    useEffect(() => {
        const location: LocationType = {
            country: params.country,
            stateProvidence: params.stateProvidence === '-' ? undefined : params.stateProvidence,
            city: params.city === '-' ? undefined : params.city,
        };

        callApi<ArtistMessage[]>(getArtistsByLocation(getAccessToken(), location), setArtistMessages);
    }, [params, getAccessToken]);

    const render = (status: Status) => (<h1>{status}</h1>);

    return (
        <>
            <ButtonBar
                leftButtons={[]}
                rightButtons={[]}
            />
            <Stack>
                <Box>
                    <Typography variant='h5'>{getLocationString({ country: params.country, stateProvidence: params.stateProvidence, city: params.city})}</Typography>
                </Box>
                <Box sx={{ pt: '12px' }}>
                    <Typography variant='h6'>{artistMessages?.length} artists</Typography>
                </Box>
            </Stack>
            <Stack>
                <Box>                    
                    <div style={{ height: '60vh', width: '100%', paddingBottom: '24px' }}>
                        <Wrapper apiKey={GoolgleApiKey} render={render}>
                            <div ref={ref as any} style={{height: "100%", width: "100%"}} ></div>
                        </Wrapper>
                    </div>
                </Box>
            </Stack>
            {artistMessages?.map((artist: ArtistMessage, index: number) =>
                <Box component={Link}
                    sx={{ 
                        width: '360px',
                        display: 'inline-flex',
                        p: '6px',
                        m: '2px',
                        textDecoration: 'none',
                        fontWeight: 'bold',
                        borderRadius: '6px',
                        backgroundColor: artist.backgroundColor,
                        color: artist.color === null || artist.color === "" ? '#666666' : artist.color ,
                    }}
                    key={`$artist-${index}`}
                    to={`/letters/${getLetter(artist.name)}/artists/${artist.name}`}
                >
                    {format(artist.name)}
                </Box>
            )}
        </>
    )
}

export default Location;